'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var clsx = require('clsx');
var nthHookTheme = require('@narvar/nth-hook-theme');
var Dismiss = require('./components/Dismiss.js');
var Alert_module = require('./Alert.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);

const REMOVAL_OFFSET = 10; // 10ms

const BlockAlert = ({
  children,
  show = false,
  dismissible = false,
  dismiss,
  dismissOnClick,
  timeout = 300 // duration
}) => {
  const {
    alertNoneNone: alertContainerStyle,
    buttonsDismissNone: buttonsDismissStyle
  } = nthHookTheme.useTheme();
  const [isFadingOut, setIsFadingOut] = React.useState(false);
  const shouldAlertRender = show || isFadingOut;
  React.useEffect(() => {
    if (!show) {
      setIsFadingOut(true);
    }
  }, [show]);
  React.useEffect(() => {
    let fadeOutTimer;
    if (isFadingOut) {
      const _timeout = timeout ? timeout + REMOVAL_OFFSET : REMOVAL_OFFSET;
      fadeOutTimer = setTimeout(() => {
        setIsFadingOut(false);
      }, _timeout);
    }
    return () => {
      if (fadeOutTimer) {
        clearTimeout(fadeOutTimer);
      }
    };
  }, [isFadingOut, timeout]);
  const style = {
    opacity: show ? 1 : 0,
    animationDuration: timeout ? `${timeout}ms` : '0ms',
    animationName: isFadingOut ? Alert_module["default"].fadeOut : 'none'
  };
  if (!shouldAlertRender) {
    return null;
  }
  const alertClasses = clsx__default["default"]({
    [Alert_module["default"].alert]: true
  });
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: Alert_module["default"].container,
    style: style
  }, dismissible && /*#__PURE__*/React__default["default"].createElement("div", {
    className: Alert_module["default"].dismiss
  }, dismiss || /*#__PURE__*/React__default["default"].createElement(Dismiss["default"], {
    s: buttonsDismissStyle,
    onClick: dismissOnClick
  })), /*#__PURE__*/React__default["default"].createElement("div", {
    className: alertClasses,
    role: "alert",
    style: alertContainerStyle
  }, children));
};
var Alert = nthHookTheme.withThemeProvider(BlockAlert, {
  themeTokens: ['alertNoneNone', 'buttonsDismissNone']
});

exports["default"] = Alert;
